<template>
  <v-text-field
    v-model="newValue"
    :placeholder="placeholder"
    color="black"
    :rules="rules"
  />
</template>

<script>
import { watch, ref } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
